webpackJsonp([8],{

/***/ "0Xdw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0bkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar__ = __webpack_require__("jdka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homeMain__ = __webpack_require__("obLl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navbar__ = __webpack_require__("o+Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: { sidebar: __WEBPACK_IMPORTED_MODULE_1__sidebar__["default"], homeMain: __WEBPACK_IMPORTED_MODULE_2__homeMain__["default"], navbar: __WEBPACK_IMPORTED_MODULE_3__navbar__["default"] },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['sidebar'])),
  methods: {}
});

/***/ }),

/***/ "1/UD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6vqN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77F4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarItem__ = __webpack_require__("h9oN");

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_2__SidebarItem__["default"] },
  data: function data() {
    return {
      themeMap: {
        1: {
          backgroundColor: '#495159',
          textColor: '#eee',
          activeTextColor: '#2d8cf0'
        },
        2: {
          backgroundColor: '#495159',
          textColor: '#eee',
          activeTextColor: '#64d572'
        },
        3: {
          backgroundColor: '#495159',
          textColor: '#eee',
          activeTextColor: '#dc9a35'
        },
        4: {
          backgroundColor: '#495159',
          textColor: '#eee',
          activeTextColor: '#f10215'
        },
        5: {
          backgroundColor: null,
          textColor: null,
          activeTextColor: null
        },
        6: {
          backgroundColor: null,
          textColor: null,
          activeTextColor: null
        },
        7: {
          backgroundColor: null,
          textColor: null,
          activeTextColor: null
        },
        8: {
          backgroundColor: null,
          textColor: null,
          activeTextColor: null
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['permissionRouters', 'sidebar', 'themeId']), {
    themeColor: function themeColor() {
      return this.themeMap[this.themeId];
    }
  }),
  created: function created() {
    console.log(this.$router.options.routes);
  },

  methods: {}
});

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("MWF8")("./" + file);
  };
};

/***/ }),

/***/ "BELG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_levelbar_vue__ = __webpack_require__("wJjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d269a656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_levelbar_vue__ = __webpack_require__("dKxm");
function injectStyle (ssrContext) {
  __webpack_require__("KxaC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d269a656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_levelbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d269a656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_levelbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DreV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qNDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c8b10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Jatp");
function injectStyle (ssrContext) {
  __webpack_require__("naPs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5c8b10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5c8b10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GLVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* 组件模块
* */
var _import = __webpack_require__("A66B");

/* harmony default export */ __webpack_exports__["a"] = ([{ path: 'index', name: '介绍', component: _import('components/index') }]);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");
/**
 * Created by huangjin on 2017/8/03.
 */







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
}));

/***/ }),

/***/ "J7SQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jatp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown',{attrs:{"trigger":"click","size":"small"},on:{"command":_vm.changeTheme}},[_c('el-button',{staticClass:"switch-theme-btn",attrs:{"type":"text"}},[_c('i',{staticClass:"iconfont icon-yanse"}),_c('i',{staticClass:"el-icon-caret-bottom"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"switch-theme",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":1}},[_c('i',{staticClass:"iconfont icon-iconfont02 blue"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===1),expression:"themeId===1"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":2}},[_c('i',{staticClass:"iconfont icon-iconfont02 green"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===2),expression:"themeId===2"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":3}},[_c('i',{staticClass:"iconfont icon-iconfont02 yellow"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===3),expression:"themeId===3"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":4}},[_c('i',{staticClass:"iconfont icon-iconfont02 red"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===4),expression:"themeId===4"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":5,"divided":""}},[_c('i',{staticClass:"iconfont icon-staro blue"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===5),expression:"themeId===5"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":6}},[_c('i',{staticClass:"iconfont icon-staro green"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===6),expression:"themeId===6"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":7}},[_c('i',{staticClass:"iconfont icon-staro yellow"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===7),expression:"themeId===7"}],staticClass:"iconfont icon-xuanzhong"})]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":8}},[_c('i',{staticClass:"iconfont icon-staro red"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.themeId===8),expression:"themeId===8"}],staticClass:"iconfont icon-xuanzhong"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jpy7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.isFullScreen ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('el-button',{staticClass:"screen-full-btn",attrs:{"type":"text"},on:{"click":_vm.click}},[_c('i',{staticClass:"iconfont",class:_vm.isFullScreen?'icon-btn_cancelFullscreen':'icon-quanping'})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K6X3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* 图表模块
* */
var _import = __webpack_require__("A66B");

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'page1',
  name: '图表-1',
  component: _import('charts/page1'),
  children: [{ path: 'index', name: '简介', component: _import('introduction/index') }]
}, {
  path: 'page2',
  name: '图表-2',
  component: _import('charts/page2')
}]);

/***/ }),

/***/ "KR+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"sidebar",class:{close:_vm.sidebar},attrs:{"background-color":_vm.themeColor.backgroundColor,"text-color":_vm.themeColor.textColor,"active-text-color":_vm.themeColor.activeTextColor,"default-active":_vm.$route.path,"router":"","collapse":_vm.sidebar}},[_c('sidebar-item',{attrs:{"routes":_vm.permissionRouters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KR8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0bkq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e45d97c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("y1SY");
function injectStyle (ssrContext) {
  __webpack_require__("1/UD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e45d97c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e45d97c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KWTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "KxaC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lvbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121203f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Lvbu");
function injectStyle (ssrContext) {
  __webpack_require__("jcQG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121203f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__("Vo7i");


// 登录
function login(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/login',
    method: 'post',
    data: data
  });
}

// 获取用户信息
function getUserInfo() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getUserInfo',
    method: 'get'
  });
}

/***/ }),

/***/ "MDhU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MWF8":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./charts/page1": [
		"fkNT",
		6
	],
	"./charts/page1.vue": [
		"fkNT",
		6
	],
	"./charts/page2": [
		"7bir",
		5
	],
	"./charts/page2.vue": [
		"7bir",
		5
	],
	"./components": [
		"DT/a",
		2
	],
	"./components/": [
		"DT/a",
		2
	],
	"./components/index": [
		"DT/a",
		2
	],
	"./components/index.vue": [
		"DT/a",
		2
	],
	"./errorPage/404": [
		"AejC",
		4
	],
	"./errorPage/404.vue": [
		"AejC",
		4
	],
	"./home": [
		"KR8f"
	],
	"./home/": [
		"KR8f"
	],
	"./home/SidebarItem": [
		"h9oN"
	],
	"./home/SidebarItem.vue": [
		"h9oN"
	],
	"./home/homeMain": [
		"obLl"
	],
	"./home/homeMain.vue": [
		"obLl"
	],
	"./home/index": [
		"KR8f"
	],
	"./home/index.vue": [
		"KR8f"
	],
	"./home/levelbar": [
		"BELG"
	],
	"./home/levelbar.vue": [
		"BELG"
	],
	"./home/navbar": [
		"o+Sv"
	],
	"./home/navbar.vue": [
		"o+Sv"
	],
	"./home/sidebar": [
		"jdka"
	],
	"./home/sidebar.vue": [
		"jdka"
	],
	"./home/tabsView": [
		"P7b9"
	],
	"./home/tabsView.vue": [
		"P7b9"
	],
	"./introduction": [
		"kdsv",
		1
	],
	"./introduction/": [
		"kdsv",
		1
	],
	"./introduction/index": [
		"kdsv",
		1
	],
	"./introduction/index.vue": [
		"kdsv",
		1
	],
	"./login/login": [
		"W2Q3",
		3
	],
	"./login/login.vue": [
		"W2Q3",
		3
	],
	"./welcome": [
		"ZO6g",
		0
	],
	"./welcome/": [
		"ZO6g",
		0
	],
	"./welcome/index": [
		"ZO6g",
		0
	],
	"./welcome/index.vue": [
		"ZO6g",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__permission__ = __webpack_require__("kTXO");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








 // 权限、路由拦截

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["b" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "P7b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabsView_vue__ = __webpack_require__("rAlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d26409_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabsView_vue__ = __webpack_require__("SO6g");
function injectStyle (ssrContext) {
  __webpack_require__("MDhU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d26409"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d26409_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SO6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-view-container"},_vm._l((Array.from(_vm.visitedViews)),function(tag){return _c('router-link',{key:tag.path,staticClass:"tabs-view",attrs:{"to":tag.path}},[_c('el-tag',{attrs:{"closable":true,"size":"small","type":_vm.isActive(tag.path)?'primary':'info'},on:{"close":function($event){_vm.closeViewTabs(tag,$event)}}},[_vm._v("\n      "+_vm._s(tag.name)+"\n    ")])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TbzR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_AUTHORIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_USERMSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SIDEBARSTATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_THEME_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_VISITED_VIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEL_VISITED_VIEWS; });
/**
 * Created by huangjin on 2017/8/03.
 */
/* eslint-disable camelcase */

var SET_AUTHORIZATION = 'SET_AUTHORIZATION'; // 设置token
var SET_USERMSG = 'SET_USERMSG'; // 设置用户信息
var SET_SIDEBARSTATUS = 'SET_SIDEBARSTATUS'; // 设置侧边栏展开状态
var SET_THEME_ID = 'SET_THEME_ID'; // 设置主题id
var ADD_VISITED_VIEWS = 'ADD_VISITED_VIEWS'; // 增加一个访问记录页签
var DEL_VISITED_VIEWS = 'DEL_VISITED_VIEWS'; // 删除一个访问记录页签

/***/ }),

/***/ "U5FJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  }
});

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by huangjin on 2018/0/8.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  permissionRouters: function permissionRouters(state) {
    return state.routers;
  }, // 路由数组
  sidebar: function sidebar(state) {
    return state.sidebarStatus;
  }, // 侧边栏展开状态
  avatar: function avatar(state) {
    return state.userMsg.avatar ? state.userMsg.avatar : 'static/img/avatar.jpg';
  },
  themeId: function themeId(state) {
    return state.themeId;
  },
  visitedViews: function visitedViews(state) {
    return state.visitedViews;
  }
});

/***/ }),

/***/ "V4kI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VKKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocalStorage;
/* unused harmony export removeLocalStorage */
/* unused harmony export setSessionStorage */
/* unused harmony export getSessionStorage */
/* unused harmony export removeSessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/*
* 存储api
*/
/*
* localStorage  Api
*/
function setLocalStorage(key, value) {
  window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
}

function getLocalStorage(value) {
  return JSON.parse(window.localStorage.getItem(value));
}

function removeLocalStorage(key) {
  window.localStorage.removeItem(key);
}

/*
* SessionStorage  Api
*/
function setSessionStorage(key, value) {
  window.sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
}

function getSessionStorage(value) {
  return JSON.parse(window.sessionStorage.getItem(value));
}

function removeSessionStorage(key) {
  window.sessionStorage.removeItem(key);
}

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BASE_API */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);







var ENV = "production";
var BASE_API = "https://www.easy-mock.com/mock/59dc61571de3d46fa94cebc7/lolapp"; //  连接测试服务器 请求跨域数据

// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: BASE_API, // api的base_url
  timeout: 10000 // 请求超时时间 10s
});

// request 请求发送之前 拦截器
service.interceptors.request.use(function (config) {
  var Authorization = Object(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getLocalStorage */])('Authorization');
  if (Authorization) {
    config.headers.Authorization = Authorization; // 让每个请求携带token--['Authorization']
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// request 请求收到后 拦截器设置
service.interceptors.response.use(function (response) {
  if (response) {
    switch (response.data.code) {
      case 'H0000':
        break;
      case 'B1000':
        // 返回 B1000 清除token信息并跳转到登录页面
        sessionStorage.setItem('session_key', null); // 将token清空
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('LogOut').then(function () {
          location.reload(); // 刷新页面
        });
        break;
      default:
        __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error(response.data.data.msg ? response.data.data.msg : '返回状态非H0000');
    }
    return response.data;
  } else {
    __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error('响应成功，但是响应信息不存在！');
  }
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
    }
  }
  __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error(ENV === 'development' ? '服务器端产生错误！' : '网络因素，请稍后重试！');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data); // 返回接口返回的错误信息
});


/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constantRouterMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_home__ = __webpack_require__("KR8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("GLVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts__ = __webpack_require__("K6X3");




var _import = __webpack_require__("A66B");
// 开发环境用同步加载，而正式环境用异步加载路由，提高开发环境的渲染效率

/**
 * icon : the icon class show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will no redirct in the levelbar
 * noDropdown : if `noDropdown:true` will has no submenu
 * meta : {  }  will control the page message
 **/





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var constantRouterMap = [{
  path: '/login',
  component: _import('login/login'),
  name: '登录页',
  hidden: true
}, {
  path: '/',
  redirect: '/home',
  component: __WEBPACK_IMPORTED_MODULE_3__views_home__["default"],
  name: '首页',
  hidden: true,
  children: [{ path: 'home', component: _import('welcome/index'), name: '欢迎登录！' }]
}, {
  path: '/introduction',
  redirect: '/introduction/welcome',
  component: __WEBPACK_IMPORTED_MODULE_3__views_home__["default"],
  noDropdown: true,
  icon: 'icon-zhuyetc',
  children: [{ path: 'index', name: '简介', component: _import('introduction/index') }]
}, {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_3__views_home__["default"],
  redirect: '/components/index',
  name: '组件',
  icon: 'icon-zujian',
  children: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* default */]))
}, {
  path: '/charts',
  component: __WEBPACK_IMPORTED_MODULE_3__views_home__["default"],
  redirect: '/charts/page1',
  name: '图表',
  icon: 'icon-chart',
  children: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__charts__["a" /* default */]))
}, {
  path: '/error',
  component: __WEBPACK_IMPORTED_MODULE_3__views_home__["default"],
  redirect: 'noredirect',
  name: '错误页面',
  icon: 'icon-shoucang',
  children: [{ path: '/404', name: '404', component: _import('errorPage/404') }]
}, { path: '*', redirect: '/404', hidden: true }];

/* harmony default export */ __webpack_exports__["b"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  }, // 滚动到指定位置
  routes: constantRouterMap
}));

/***/ }),

/***/ "Z+Ut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aJmA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.routes),function(item){return [(!item.hidden && item.noDropdown && item.children.length>0)?_c('el-menu-item',{attrs:{"index":item.path+'/'+item.children[0].path}},[(item.icon)?_c('i',{class:("iconfont " + (item.icon))}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.children[0].name))])]):_vm._e(),_vm._v(" "),(!item.noDropdown&&!item.hidden)?_c('el-submenu',{attrs:{"index":item.name}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[(item.icon)?_c('i',{class:("iconfont " + (item.icon))}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child){return (!child.hidden)?[(child.children&&child.children.length>0)?_c('sidebar-item',{staticClass:"nest-menu",attrs:{"routes":[child]}}):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":item.path+'/'+child.path}},[(child.icon)?_c('i',{class:("iconfont " + (item.icon))}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(child.name))])])]:_vm._e()})],2):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "afte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull__ = __webpack_require__("I95x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_screenfull__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'screenfull',
  data: function data() {
    return {
      isFullScreen: false
    };
  },

  methods: {
    click: function click() {
      if (!__WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      this.isFullScreen = !this.isFullScreen;
      __WEBPACK_IMPORTED_MODULE_0_screenfull___default.a.toggle();
    }
  }
});

/***/ }),

/***/ "dKxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"app-levelbar",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.levelList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":item.redirect||item.path}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ecFT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Screenfull__ = __webpack_require__("k0sJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SwitchTheme__ = __webpack_require__("DreV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabsView__ = __webpack_require__("P7b9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__levelbar__ = __webpack_require__("BELG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { levelbar: __WEBPACK_IMPORTED_MODULE_5__levelbar__["default"], Screenfull: __WEBPACK_IMPORTED_MODULE_2__components_Screenfull__["a" /* default */], tabsView: __WEBPACK_IMPORTED_MODULE_4__tabsView__["default"], SwitchTheme: __WEBPACK_IMPORTED_MODULE_3__components_SwitchTheme__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sidebar', 'name', 'avatar'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
      console.log(this.sidebar);
    },
    logout: function logout() {
      this.$store.dispatch('LogOut').then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
});

/***/ }),

/***/ "h9oN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("U5FJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("aJmA");
function injectStyle (ssrContext) {
  __webpack_require__("0Xdw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6993cdce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6993cdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jcQG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jdka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("77F4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaca2af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("KR+a");
function injectStyle (ssrContext) {
  __webpack_require__("Z+Ut")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eaca2af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaca2af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "k0sJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("afte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_558822a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Jpy7");
function injectStyle (ssrContext) {
  __webpack_require__("J7SQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-558822a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_558822a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
var _this = this;



 // Progress 进度条
 // Progress 进度条样式


var whiteList = ['/login']; // 不需要权限验证拦截的白名单路由
__WEBPACK_IMPORTED_MODULE_0__router__["b" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start(); // 开启Progress
  if (localStorage.getItem('Authorization')) {
    if (to.path === '/login') {
      next({ path: '/' });
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
    } else {
      if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.userMsg) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('GetInfo', _this.form).then(function (res) {
          _this.loading = false;
          if (res.code === 'H0000' && res.data) {
            next();
          } else {
            console.log('login error');
            __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error('拉取用户信息失败');
          }
        }).catch(function () {
          _this.loading = false;
          __WEBPACK_IMPORTED_MODULE_4_element_ui__["Message"].error('拉取用户信息失败');
          next();
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0__router__["b" /* default */].afterEach(function () {
  __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done(); // 结束Progress
});

/***/ }),

/***/ "lcJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/**
 * Created by huangjin on 2017/11/03.
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  userMsg: null, // 用户信息
  routers: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* constantRouterMap */],
  sidebarStatus: Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* getLocalStorage */])('sidebarStatus') !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* getLocalStorage */])('sidebarStatus') : false,
  themeId: Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* getLocalStorage */])('themeId') !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* getLocalStorage */])('themeId') : 1,
  visitedViews: [] // 访问过的页面
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("TbzR");


/**
 * Created by huangjin on 2017/8/03.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  // 登录
  Login: function Login(_ref, userInfo) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_2__api_login__["b" /* login */])(userInfo).then(function (response) {
        if (response.code === 'H0000') {
          Object(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setLocalStorage */])('Authorization', response.data.token); // 用户token 存到本地
          commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* SET_AUTHORIZATION */], response.data.token);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取用户信息
  GetInfo: function GetInfo(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Object(__WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* getUserInfo */])().then(function (response) {
        if (response.code === 'H0000' && response.data) {
          commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* SET_USERMSG */], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 登出
  LogOut: function LogOut(_ref3) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* SET_AUTHORIZATION */], '');
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* SET_USERMSG */], null);
      localStorage.removeItem('Authorization');
      resolve();
    });
  },

  // 设置侧边栏是否展开
  ToggleSideBar: function ToggleSideBar(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* SET_SIDEBARSTATUS */]);
  },

  // 设置主题Id
  SetTheme: function SetTheme(_ref5, themeId) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* SET_THEME_ID */], themeId);
  },

  // 增加一个访问记录
  AddVisitedViews: function AddVisitedViews(_ref6, view) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* ADD_VISITED_VIEWS */], view);
  },

  // 删除一个访问记录
  DelVisitedViews: function DelVisitedViews(_ref7, view) {
    var commit = _ref7.commit,
        state = _ref7.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* DEL_VISITED_VIEWS */], view);
      resolve([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.visitedViews)));
    });
  }
});

/***/ }),

/***/ "naPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o+Sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__("ecFT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63eb71d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__("rpao");
function injectStyle (ssrContext) {
  __webpack_require__("6vqN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63eb71d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63eb71d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "obLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeMain_vue__ = __webpack_require__("KWTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12bb5504_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeMain_vue__ = __webpack_require__("lcJi");
function injectStyle (ssrContext) {
  __webpack_require__("V4kI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12bb5504"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12bb5504_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qNDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_storage__ = __webpack_require__("VKKs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      themeId: Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* getLocalStorage */])('themeId') || 1
    };
  },
  created: function created() {
    this.changeTheme(this.themeId);
  },

  methods: {
    changeTheme: function changeTheme(value) {
      this.themeId = value;
      this.$store.dispatch('SetTheme', value);
      var themeMap = {
        1: 'blue',
        2: 'green',
        3: 'yellow',
        4: 'red',
        5: 'blue',
        6: 'green',
        7: 'yellow',
        8: 'red'
      };
      var oldCss = document.getElementById('add-theme');
      var head = document.getElementsByTagName('head')[0];
      oldCss && head.removeChild(oldCss);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["b" /* setLocalStorage */])('themeId', value);

      if (value === 1 || value === 5) {
        return;
      }
      // 需要移到单独的文件存放
      var themeSrc = '/static/theme/' + themeMap[value] + '/index.css';
      loadCss(themeSrc);

      function loadCss(path) {
        var link = document.createElement('link');
        link.id = 'add-theme';
        link.href = path;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        head.appendChild(link);
      }
    }
  }
});

/***/ }),

/***/ "rAlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.visitedViews.slice(-6);
    }
  },
  methods: {
    closeViewTabs: function closeViewTabs(view, $event) {
      var _this = this;

      this.$store.dispatch('DelVisitedViews', view).then(function (views) {
        if (_this.isActive(view.path)) {
          var latestView = views.slice(-1)[0];
          if (latestView) {
            _this.$router.push(latestView.path);
          } else {
            _this.$router.push('/');
          }
        }
      });
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    addViewTabs: function addViewTabs() {
      var route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch('AddVisitedViews', this.generateRoute());
    },
    isActive: function isActive(path) {
      return path === this.$route.path;
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTabs();
    }
  }
});

/***/ }),

/***/ "rpao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"navbar-left"},[_c('el-button',{staticClass:"sidebar-btn",on:{"click":_vm.toggleSideBar}},[_c('i',{staticClass:"iconfont icon-p-menus",class:{left:!_vm.sidebar}})]),_vm._v(" "),_c('levelbar'),_vm._v(" "),_c('tabs-view')],1),_vm._v(" "),_c('div',{staticClass:"navbar-right"},[_c('div',{staticClass:"navbar-right-item"},[_c('screenfull')],1),_vm._v(" "),_c('div',{staticClass:"navbar-right-item"},[_c('switch-theme')],1),_vm._v(" "),_c('el-dropdown',{staticClass:"avatar-container",attrs:{"trigger":"click"}},[_c('div',{staticClass:"avatar-wrapper navbar-right-item"},[_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.avatar}}),_vm._v(" "),_c('i',{staticClass:"on bottom b-white"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"user-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('router-link',{staticClass:"inlineBlock",attrs:{"to":"/"}},[_vm._v("\n            首页\n          ")])],1),_vm._v(" "),_c('el-dropdown-item',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/huangjincq/vue-admin-template"}},[_vm._v("\n            项目地址\n          ")])]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""}},[_c('span',{staticStyle:{"display":"block"},on:{"click":_vm.logout}},[_vm._v("退出登录")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("TbzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage__ = __webpack_require__("VKKs");




var _types$SET_AUTHORIZAT;

/**
 * Created by huangjin on 2017/8/03.
 */



/* harmony default export */ __webpack_exports__["a"] = (_types$SET_AUTHORIZAT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_AUTHORIZATION */], function (state, authorization) {
  state.authorization = authorization;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_USERMSG */], function (state, userMsg) {
  state.userMsg = userMsg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_SIDEBARSTATUS */], function (state) {
  if (state.sidebarStatus) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["b" /* setLocalStorage */])('sidebarStatus', false);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["b" /* setLocalStorage */])('sidebarStatus', true);
  }
  state.sidebarStatus = !state.sidebarStatus;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_THEME_ID */], function (state, themeId) {
  state.themeId = themeId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADD_VISITED_VIEWS */], function (state, view) {
  if (state.visitedViews.some(function (v) {
    return v.path === view.path;
  })) return;
  state.visitedViews.push({ name: view.name, path: view.path });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_AUTHORIZAT, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* DEL_VISITED_VIEWS */], function (state, view) {
  var index = void 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var i = _ref2[0];
      var v = _ref2[1];

      if (v.path === view.path) {
        index = i;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  state.visitedViews.splice(index, 1);
}), _types$SET_AUTHORIZAT);

/***/ }),

/***/ "wJjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    levelList: function levelList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== '首页' || first.path !== '')) {
        matched = [{ name: '首页', path: '/' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(matched));
      }
      return matched;
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "y1SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"main"}},[_c('sidebar'),_vm._v(" "),_c('el-container',{staticClass:"container-right",class:{close:_vm.sidebar}},[_c('el-header',{attrs:{"height":"50px"}},[_c('navbar')],1),_vm._v(" "),_c('el-main',[_c('home-main')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5e7d2f020473c974994a.js